// Custom Messages

export const frCustomMessages = {
  "pages": {
    "login": {
          "sighInTitle": "Connectez-vous à SINETOS",
      "username": "Nom d'utilisateur",
      "email": "E-mail",
      "password": "Mot de passe",
      "rememberMe": "Se souvenir de moi",
      "welcome": "Bienvenue",
      "login": "Connexion"
    },
    "welcome": {
      "home": "Accueil",
      "features": "Fonctionnalités",
      "events": "Événements",
      "pricing": "Tarification",
      "title": "Trouvez des biens immobiliers en Grèce et à Chypre",
      "login": "Connexion",
      "logout": "Déconnexion",
      "dashboard": "Tableau de bord"
    },
    "emailAccount": {
      "createUser": "Envoyer un e-mail à",
      "sendTestEmailToTitle": "Envoyez un e-mail de test pour vous assurer que tout est correctement configuré."
    },
    "portfolio": {
      "upload": "Téléverser",
      "download": "Télécharger",
      "approval": "Approbation",
      "emailInfo": "Infos e-mail",
      "restrictions": {
        "maxFileSize": "Limite de taille du document < 2.097.152 Ko"
      }
    }
  },
  "common": {
    "cancel": "Annuler",
    "employee": "Employé",
    "user": "Utilisateur",
    "confirmation": "Confirmation",
    "delete": "Supprimer",
    "settings": "Paramètres",
    "actions": "Actions",
    "languages": "Langues",
    "logout": "Déconnexion",
    "importResources": "Ressources d'insertion",
    "execute": "Exécuter",
    "clearAll": "Effacer les enregistrements",
    "mark": "Marquer"
  },
  "messages": {
    "deleteFile": "Supprimer le fichier",
    "sendingEmail": "Envoi de l'e-mail",
    "createNewUser": "Créer un nouvel utilisateur.",
    "clearAllCompleted": "Effacement des enregistrements terminé.",
    "emailSendingSuccessfullyCompleted": "Envoi de l'e-mail terminé avec succès.",
    "editSuccessfullyCompleted": "Modification terminée avec succès.",
    "uploadSuccessfullyCompleted": "Téléversement terminé avec succès.",
    "deleteFileSuccessfullyCompleted": "Suppression du fichier terminée avec succès."
  }
};

// Kendo Angular Component Messages
export const frComponentMessages = {
    // Grid
    "kendo.grid.groupPanelEmpty": "Faites glisser un en-tête de colonne ici pour grouper par cette colonne.",
    "kendo.grid.noRecords": "Aucun enregistrement disponible.",
    "kendo.grid.pagerFirstPage": "Aller à la première page.",
    "kendo.grid.pagerPreviousPage": "Aller à la page précédente.",
    "kendo.grid.pagerNextPage": "Aller à la page suivante.",
    "kendo.grid.pagerLastPage": "Aller à la dernière page.",
    "kendo.grid.pagerPage": "Page",
    "kendo.grid.pagerOf": "sur",
    "kendo.grid.pagerItems": "éléments",
    "kendo.grid.pagerItemsPerPage": "éléments par page",
    "kendo.grid.pagerPageNumberInputTitle": "Numéro de page",
    "kendo.grid.filter": "Filtre",
    "kendo.grid.filterEqOperator": "Est égal à",
    "kendo.grid.filterNotEqOperator": "N'est pas égal à",
    "kendo.grid.filterIsNullOperator": "Est nul",
    "kendo.grid.filterIsNotNullOperator": "N'est pas nul",
    "kendo.grid.filterIsEmptyOperator": "Est vide",
    "kendo.grid.filterIsNotEmptyOperator": "N'est pas vide",
    "kendo.grid.filterStartsWithOperator": "Commence par",
    "kendo.grid.filterContainsOperator": "Contient",
    "kendo.grid.filterNotContainsOperator": "Ne contient pas",
    "kendo.grid.filterEndsWithOperator": "Se termine par",
    "kendo.grid.filterGteOperator": "Est supérieur ou égal à",
    "kendo.grid.filterGtOperator": "Est supérieur à",
    "kendo.grid.filterLteOperator": "Est inférieur ou égal à",
    "kendo.grid.filterLtOperator": "Est inférieur à",
    "kendo.grid.filterIsTrue": "est vrai",
    "kendo.grid.filterIsFalse": "est faux",
    "kendo.grid.filterBooleanAll": "(Tous)",
    "kendo.grid.filterAfterOrEqualOperator": "Est après ou égal à",
    "kendo.grid.filterAfterOperator": "Est après",
    "kendo.grid.filterBeforeOperator": "Est avant",
    "kendo.grid.filterBeforeOrEqualOperator": "Est avant ou égal à",
    "kendo.grid.filterFilterButton": "Filtrer",
    "kendo.grid.filterClearButton": "Effacer",
    "kendo.grid.filterAndLogic": "Et",
    "kendo.grid.filterOrLogic": "Ou",
    "kendo.grid.filterDateToggle": "Basculer le calendrier",
    "kendo.grid.filterDateToday": "Aujourd'hui",
    "kendo.grid.filterNumericDecrement": "Diminuer la valeur",
    "kendo.grid.filterNumericIncrement": "Augmenter la valeur",
    "kendo.grid.loading": "Chargement",
    "kendo.grid.columns": "Colonnes",
    "kendo.grid.lock": "Verrouiller",
    "kendo.grid.unlock": "Déverrouiller",
    "kendo.grid.stick": "Fixer",
    "kendo.grid.unstick": "Détacher",
    "kendo.grid.setColumnPosition": "Définir la position de la colonne",
    "kendo.grid.sortAscending": "Trier par ordre croissant",
    "kendo.grid.sortDescending": "Trier par ordre décroissant",
    "kendo.grid.columnsApply": "Appliquer",
    "kendo.grid.columnsReset": "Réinitialiser",
    "kendo.grid.sortable": "Triable",
    "kendo.grid.sortedAscending": "Trié par ordre croissant",
    "kendo.grid.sortedDescending": "Trié par ordre décroissant",
    "kendo.grid.sortedDefault": "Non trié",
    "kendo.grid.filterInputLabel": "Filtre {columnName}",
    "kendo.grid.filterMenuTitle": "Menu filtre {columnName}",
    "kendo.grid.filterMenuOperatorsDropDownLabel": "Opérateurs de filtre {columnName}",
    "kendo.grid.filterMenuLogicDropDownLabel": "Logique du filtre {columnName}",
    "kendo.grid.columnMenu": "Menu colonne {columnName}",
    "kendo.grid.selectionCheckboxLabel": "Sélectionner la ligne",
    "kendo.grid.selectAllCheckboxLabel": "Sélectionner toutes les lignes",
    "kendo.grid.pagerLabel": "Navigation des pages, page {currentPage} sur {totalPages}",
    "kendo.grid.gridLabel": "Tableau de données",
    "kendo.grid.groupCollapse": "Réduire le groupe",
    "kendo.grid.groupExpand": "Développer le groupe",
    "kendo.grid.detailCollapse": "Réduire les détails",
    "kendo.grid.detailExpand": "Développer les détails",
    "kendo.grid.autosizeThisColumn": "Ajuster automatiquement cette colonne",
    "kendo.grid.autosizeAllColumns": "Ajuster automatiquement toutes les colonnes",
    "kendo.grid.pagerSelectPage": "Sélectionner une page",
    "kendo.grid.topToolbarLabel": "Barre d'outils supérieure",
    "kendo.grid.bottomToolbarLabel": "Barre d'outils inférieure",
    "kendo.grid.groupPanelLabel": "Panneau de regroupement",
    "kendo.grid.dragRowHandleLabel": "Faire glisser la ligne",
    "kendo.grid.selectRowCheckboxLabel": "Sélectionner la ligne",
    "kendo.grid.selectAllRowsCheckboxLabel": "Sélectionner toutes les lignes",
    "kendo.grid.filterCellOperatorLabel": "Opérateurs de filtre de cellule pour {columnName}",
    "kendo.grid.booleanFilterCellLabel": "Filtre booléen pour {columnName}",
    "kendo.grid.columnMenuFilterTabTitle": "Filtre",
    "kendo.grid.columnMenuGeneralTabTitle": "Général",
    "kendo.grid.columnMenuColumnsTabTitle": "Colonnes",
    "kendo.grid.groupChipMenuPrevious": "Déplacer comme précédent",
    "kendo.grid.groupChipMenuNext": "Déplacer comme suivant",
    "kendo.grid.pagerInputLabel": "Saisissez un numéro de page",

    // Filter
    "kendo.filter.addExpression": "Ajouter une expression",
    "kendo.filter.addFilter": "Ajouter un filtre",
    "kendo.filter.addGroup": "Ajouter un groupe",
    "kendo.filter.remove": "Supprimer",
    "kendo.filter.editorDateTodayText": "Aujourd'hui",
    "kendo.filter.editorDateToggleText": "Basculer le calendrier",
    "kendo.filter.editorNumericDecrement": "Diminuer",
    "kendo.filter.editorNumericIncrement": "Augmenter",
    "kendo.filter.filterAfterOperator": "Est après",
    "kendo.filter.filterAfterOrEqualOperator": "Est après ou égal à",
    "kendo.filter.filterAndLogic": "Et",
    "kendo.filter.filterBeforeOperator": "Est avant",
    "kendo.filter.filterBeforeOrEqualOperator": "Est avant ou égal à",
    "kendo.filter.filterBooleanAll": "(Tous)",
    "kendo.filter.filterContainsOperator": "Contient",
    "kendo.filter.filterEndsWithOperator": "Se termine par",
    "kendo.filter.filterEqOperator": "Est égal à",
    "kendo.filter.filterExpressionFilters": "Filtres",
    "kendo.filter.filterExpressionOperators": "Opérateurs",
    "kendo.filter.filterGtOperator": "Est supérieur à",
    "kendo.filter.filterGteOperator": "Est supérieur ou égal à",
    "kendo.filter.filterIsEmptyOperator": "Est vide",
    "kendo.filter.filterIsFalse": "Est faux",
    "kendo.filter.filterIsTrue": "Est vrai",
    "kendo.filter.filterIsNotEmptyOperator": "N'est pas vide",
    "kendo.filter.filterIsNotNullOperator": "N'est pas nul",
    "kendo.filter.filterIsNullOperator": "Est nul",
    "kendo.filter.filterLtOperator": "Est inférieur à",
    "kendo.filter.filterLteOperator": "Est inférieur ou égal à",
    "kendo.filter.filterNotContainsOperator": "Ne contient pas",
    "kendo.filter.filterNotEqOperator": "N'est pas égal à",
    "kendo.filter.filterOrLogic": "Ou",
    "kendo.filter.filterStartsWithOperator": "Commence par",
    "kendo.filter.filterFieldAriaLabel": "champ",
    "kendo.filter.filterOperatorAriaLabel": "opérateur",
    "kendo.filter.filterValueAriaLabel": "valeur",
    "kendo.filter.filterAriaLabel": "filtre",
    "kendo.filter.filterToolbarAriaLabel": "paramètres du filtre",

    // DropDowns
    'kendo.autocomplete.noDataText': 'No data found',
    'kendo.autocomplete.clearTitle': 'Clear',
    'kendo.combobox.noDataText': 'No data found',
    'kendo.combobox.clearTitle': 'Clear',
    'kendo.dropdownlist.noDataText': 'No data found',
    'kendo.dropdownlist.clearTitle': 'Clear',

    // Calendar
    'kendo.calendar.today': 'TODAY',

    // TextBox
    'kendo.textbox.clearTitle': 'Clear',

    // DatePicker
    'kendo.datepicker.today': 'TODAY',
    'kendo.datepicker.toggle': 'Toggle calendar',

    // DateInput
    'kendo.dateinput.increment': 'Increase value',
    'kendo.dateinput.decrement': 'Decrease value',

    // NumericTextBox
    'kendo.numerictextbox.increment': 'Increase value',
    'kendo.numerictextbox.decrement': 'Decrease value',

    // DateTimePicker
    'kendo.datetimepicker.dateTab': 'Date',
    'kendo.datetimepicker.dateTabLabel': 'Date tab',
    'kendo.datetimepicker.timeTab': 'Time',
    'kendo.datetimepicker.timeTabLabel': 'Time tab',
    'kendo.datetimepicker.toggle': 'Toggle popup',
    'kendo.datetimepicker.accept': 'Set',
    'kendo.datetimepicker.acceptLabel': 'Set',
    'kendo.datetimepicker.cancel': 'Cancel',
    'kendo.datetimepicker.cancelLabel': 'Cancel',
    'kendo.datetimepicker.now': 'NOW',
    'kendo.datetimepicker.nowLabel': 'Select now',
    'kendo.datetimepicker.today': 'TODAY',
    'kendo.datetimepicker.prevButtonTitle': 'Navigate to previous view',
    'kendo.datetimepicker.nextButtonTitle': 'Navigate to next view',

    // TimePicker
    'kendo.timepicker.accept': 'Set',
    'kendo.timepicker.acceptLabel': 'Set',
    'kendo.timepicker.cancel': 'Cancel',
    'kendo.timepicker.cancelLabel': 'Cancel',
    'kendo.timepicker.now': 'Now',
    'kendo.timepicker.nowLabel': 'Now',
    'kendo.timepicker.toggle': 'Toggle time list',

    // FileSelect
    'kendo.fileselect.cancel': 'Cancel',
    'kendo.fileselect.clearSelectedFiles': 'Clear',
    'kendo.fileselect.dropFilesHere': 'Drop files here to upload',
    'kendo.fileselect.externalDropFilesHere': 'Drag and drop files here to upload',
    'kendo.fileselect.filesBatchStatus': 'files',
    'kendo.fileselect.filesBatchStatusFailed': 'files failed to upload.',
    'kendo.fileselect.filesBatchStatusUploaded': 'files successfully uploaded.',
    'kendo.fileselect.fileStatusFailed': 'File failed to upload.',
    'kendo.fileselect.fileStatusUploaded': 'File successfully uploaded.',
    'kendo.fileselect.headerStatusPaused': 'Paused',
    'kendo.fileselect.headerStatusUploaded': 'Done',
    'kendo.fileselect.headerStatusUploading': 'Uploading...',
    'kendo.fileselect.invalidFileExtension': 'File type not allowed.',
    'kendo.fileselect.invalidMaxFileSize': 'File size too large.',
    'kendo.fileselect.invalidMinFileSize': 'File size too small.',
    'kendo.fileselect.remove': 'Remove',
    'kendo.fileselect.retry': 'Retry',
    'kendo.fileselect.select': 'Select files...',
    'kendo.fileselect.uploadSelectedFiles': 'Upload files',

    // Scheduler
    "kendo.scheduler.agendaViewTitle": "Agenda",
    "kendo.scheduler.allDay": "all day",
    "kendo.scheduler.allEvents": "All events",
    "kendo.scheduler.calendarToday": "TODAY",
    "kendo.scheduler.cancel": "Cancel",
    "kendo.scheduler.save": "Save",
    "kendo.scheduler.editorEventTitle": "Title",
    "kendo.scheduler.editorEventStart": "Start",
    "kendo.scheduler.editorEventStartTimeZone": "Start Time Zone",
    "kendo.scheduler.editorEventEnd": "End",
    "kendo.scheduler.editorEventEndTimeZone": "End Time Zone",
    "kendo.scheduler.dateHeader": "Date",
    "kendo.scheduler.dayViewTitle": "Day",
    "kendo.scheduler.deleteConfirmation": "Are you sure you want to delete this event?",
    "kendo.scheduler.deleteDialogTitle": "Delete Event",
    "kendo.scheduler.deleteOccurrence": "Delete current occurrence",
    "kendo.scheduler.deleteRecurringConfirmation": "Do you want to delete only this event occurrence or the whole series?",
    "kendo.scheduler.deleteRecurringDialogTitle": "Delete Recurring Item",
    "kendo.scheduler.deleteSeries": "Delete the series",
    "kendo.scheduler.deleteTitle": "Delete",
    "kendo.scheduler.destroy": "Delete",
    "kendo.scheduler.editOccurrence": "Edit current occurrence",
    "kendo.scheduler.editorEventAllDay": "All Day Event",
    "kendo.scheduler.editorEventDescription": "Description",
    "kendo.scheduler.editorEventSeparateTimeZones": "End in different Time Zone",
    "kendo.scheduler.editorEventTimeZone": "Specify Time Zone",
    "kendo.scheduler.editorTitle": "Event",
    "kendo.scheduler.editRecurringConfirmation": "Do you want to edit only this event occurrence or the whole series?",
    "kendo.scheduler.editRecurringDialogTitle": "Edit Recurring Item",
    "kendo.scheduler.editSeries": "Edit the series",
    "kendo.scheduler.eventHeader": "Event",
    "kendo.scheduler.monthViewTitle": "Month",
    "kendo.scheduler.multiDayViewTitle": "Multi-Day",
    "kendo.scheduler.nextTitle": "Next",
    "kendo.scheduler.previousTitle": "Previous",
    "kendo.scheduler.recurrenceEditorDailyInterval": "day(s)",
    "kendo.scheduler.recurrenceEditorDailyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorEndAfter": "After",
    "kendo.scheduler.recurrenceEditorEndLabel": "End",
    "kendo.scheduler.recurrenceEditorEndNever": "Never",
    "kendo.scheduler.recurrenceEditorEndOccurrence": "occurrence(s)",
    "kendo.scheduler.recurrenceEditorEndOn": "On",
    "kendo.scheduler.recurrenceEditorFrequenciesDaily": "Daily",
    "kendo.scheduler.recurrenceEditorFrequenciesMonthly": "Monthly",
    "kendo.scheduler.recurrenceEditorFrequenciesNever": "Never",
    "kendo.scheduler.recurrenceEditorFrequenciesWeekly": "Weekly",
    "kendo.scheduler.recurrenceEditorFrequenciesYearly": "Yearly",
    "kendo.scheduler.recurrenceEditorMonthlyDay": "Day",
    "kendo.scheduler.recurrenceEditorMonthlyInterval": "month(s)",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatOn": "Repeat on",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFirst": "First",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFourth": "Fourth",
    "kendo.scheduler.recurrenceEditorOffsetPositionsLast": "Last",
    "kendo.scheduler.recurrenceEditorOffsetPositionsSecond": "Second",
    "kendo.scheduler.recurrenceEditorOffsetPositionsThird": "Third",
    "kendo.scheduler.recurrenceEditorRepeat": "Repeat",
    "kendo.scheduler.recurrenceEditorWeekdaysDay": "Day",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekday": "Weekday",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekendday": "Weekend Day",
    "kendo.scheduler.recurrenceEditorWeeklyInterval": "week(s)",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatOn": "Repeat on",
    "kendo.scheduler.recurrenceEditorYearlyInterval": "year(s)",
    "kendo.scheduler.recurrenceEditorYearlyOf": "of",
    "kendo.scheduler.recurrenceEditorYearlyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorYearlyRepeatOn": "Repeat on",
    "kendo.scheduler.showFullDay": "Show full day",
    "kendo.scheduler.showWorkDay": "Show business hours",
    "kendo.scheduler.timeHeader": "Time",
    "kendo.scheduler.timelineMonthViewTitle": "Timeline Month",
    "kendo.scheduler.timelineViewTitle": "Timeline",
    "kendo.scheduler.timelineWeekViewTitle": "Timeline Week",
    "kendo.scheduler.today": "Today",
    "kendo.scheduler.weekViewTitle": "Week",
    "kendo.scheduler.workWeekViewTitle": "Work Week",

    // RecurrenceEditor
    "kendo.recurrenceeditor.dailyInterval": "day(s)",
    "kendo.recurrenceeditor.dailyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.endAfter": "After",
    "kendo.recurrenceeditor.endLabel": "End",
    "kendo.recurrenceeditor.endNever": "Never",
    "kendo.recurrenceeditor.endOccurrence": "occurrence(s)",
    "kendo.recurrenceeditor.endOn": "On",
    "kendo.recurrenceeditor.frequenciesDaily": "Daily",
    "kendo.recurrenceeditor.frequenciesMonthly": "Monthly",
    "kendo.recurrenceeditor.frequenciesNever": "Never",
    "kendo.recurrenceeditor.frequenciesWeekly": "Weekly",
    "kendo.recurrenceeditor.frequenciesYearly": "Yearly",
    "kendo.recurrenceeditor.monthlyDay": "Day",
    "kendo.recurrenceeditor.monthlyInterval": "month(s)",
    "kendo.recurrenceeditor.monthlyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.monthlyRepeatOn": "Repeat on",
    "kendo.recurrenceeditor.offsetPositionsFourth": "Fourth",
    "kendo.recurrenceeditor.offsetPositionsLast": "Last",
    "kendo.recurrenceeditor.offsetPositionsSecond": "Second",
    "kendo.recurrenceeditor.offsetPositionsThird": "Third",
    "kendo.recurrenceeditor.repeat": "Repeat",
    "kendo.recurrenceeditor.weekdaysDay": "Day",
    "kendo.recurrenceeditor.weekdaysWeekday": "Weekday",
    "kendo.recurrenceeditor.weekdaysWeekendday": "Weekend Day",
    "kendo.recurrenceeditor.weeklyInterval": "week(s)",
    "kendo.recurrenceeditor.weeklyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.weeklyRepeatOn": "Repeat on",
    "kendo.recurrenceeditor.yearlyInterval": "year(s)",
    "kendo.recurrenceeditor.yearlyOf": "of",
    "kendo.recurrenceeditor.yearlyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.yearlyRepeatOn": "Repeat on",
};
